export interface IPeriodoBeca {
  fechaInicioEstudios?: string | null;
  fechaFinEstudios?: string | null;
  fechaInicioBeca?: string | null;
  fechaFinBeca?: string | null;
  duracionBeca?: number | null;
  duracionEstudios?: number | null;
  periodicidad?: string | null;
  rangoFechasBecaEditado?: boolean | null;
}

export class PeriodoBeca implements IPeriodoBeca {
  constructor(
    public fechaInicioEstudios?: string | null,
    public fechaFinEstudios?: string | null,
    public fechaInicioBeca?: string | null,
    public fechaFinBeca?: string | null,
    public duracionBeca?: number | null,
    public duracionEstudios?: number | null,
    public periodicidad?: string | null,
    public rangoFechasBecaEditado?: boolean | null
  ) {}
}
